import { accessAtLeastManager } from 'charts/common/access';
import { AnalyticsTranslationKeys } from 'intl/keys';
import { EMPTY_VALUES_AND_LABELS, useGetChart } from 'charts/common/hooks';
import { useMemo } from 'react';
import {
  ChartType,
  InspectionChart,
  CompletedInspectionsByTemplateFilters,
} from 'shared/types/analytics';
import type { ChartRuntime } from 'views/analytics/types';
import { useCompletedInspectionsByTemplateFilters } from './filters';
import { mapValuesAndLabels } from 'charts/model/mapSeriesToRawData';
import { useInspectionTemplates } from 'store/inspection';

export function useCompletedInspectionsByTemplate(): ChartRuntime<CompletedInspectionsByTemplateFilters> {
  const { inspectionTemplates, loading: loadingTemplates } =
    useInspectionTemplates();

  const memoedTemplates = useMemo(
    () => ({
      templates: inspectionTemplates.items,
    }),
    [inspectionTemplates]
  );

  const filters = useCompletedInspectionsByTemplateFilters();
  const { series, loading, load, reload, updatedAt } =
    useGetChart({ chart: InspectionChart.completedInspectionsByTemplate, filters, additionalParams: memoedTemplates, initialSeries: EMPTY_VALUES_AND_LABELS });

  const rawData = useMemo(() => mapValuesAndLabels(series), [series]);

  return {
    filters,
    titleId: AnalyticsTranslationKeys.inspectionsByTemplateChart,
    chartType: ChartType.donut,
    canAccess: accessAtLeastManager,
    loading: !filters || loading || loadingTemplates,
    load,
    forceUpdate: reload,
    updatedAt: (): number => updatedAt,
    rawData,
  };
}
